import { Injectable } from '@angular/core';
import {ProjectElement} from '../../../resources/element/project-element.interface';
import {ProjectModule} from '../../../resources/module/project-module.interface';
import {ProjectSubmodule} from '../../../resources/submodule/project-submodule.interface';
import {BasicArea} from '../../../resources/basic-area/basic-area.interface';
import {Building} from '../../../resources/building/building.interface';
import {Cluster} from '../../../resources/cluster/cluster.interface';
import {Area} from '../../../resources/area/area.interface';
import {Project} from '../../../resources/project/project.interface';
import {ProjectModuleStore} from '../project-module/project-module-store';
import {ProjectSubmoduleStore} from '../project-submodule/project-submodule-store';
import {ProjectElementStore} from '../project-element/project-element-store';
import {BasicAreaStore} from '../basicarea/basicarea-store';
import {BuildingStore} from '../building/building-store';
import {ClusterStore} from '../cluster/cluster-store';
import {UserStore} from '../user/user-store';
import {AreaStore} from '../area/area-store';
import {ProjectStore} from './project-store';
import {ElementLogStore} from '../element-log/element-log-store';
import {ElementLog} from '../element-log/element-log.interface';
import {ProjectChapterService} from '../../../services/project-chapter/project-chapter.service';
import { User } from '../../../resources/user/user.interface';

@Injectable({
  providedIn: 'root'
})

/**
 * This services loads a single full project json returned from the MONGO db api
 * And converts it to a relation store model
 */
export class ProjectInitializerService {

  private project: Project;
  constructor(private projectStore: ProjectStore,
              private projectModuleStore: ProjectModuleStore,
              private projectSubmoduleStore: ProjectSubmoduleStore,
              private projectElementStore: ProjectElementStore,
              private basicAreaStore: BasicAreaStore,
              private buildingStore: BuildingStore,
              private clusterStore: ClusterStore,
              private userStore: UserStore,
              private areaStore: AreaStore,
              private elementLogStore: ElementLogStore,

              // @TODO eigenlijk even kijken of deze op een andere plek aangeroepen kan worden.
              // deze moet namelijk altijd draaien
              private projectChapterService: ProjectChapterService
  )  { }

  load(project) {
    if (project) {

      // Make sure we don't do a double load
      if (this.project && project._id === this.project._id) {
        return;
      }

      this.project = project;

      this.loadModulesSubmodulesElements();
      this.loadBuildingsClustersAreas();
      this.loadUsers();
      this.loadBasicAreas();

      this.projectStore.setState([this.project]);

    }
  }

  loadModulesSubmodulesElements() {
    const elements: ProjectElement[] = [];
    const modules: ProjectModule[] = [];
    const submodules: ProjectSubmodule[] = [];
    const elementLogs: ElementLog[] = [];

    for (const module of this.project.modules) {
      if (module.active) {
        module.projectId = this.project._id;
        module.versionId = this.project.versionId;

        modules.push(module);
        for (const submodule of module.submodules) {
          if (submodule.active) {
            submodule.moduleId = module._id;
            submodule.projectId = module.projectId;
            submodule.versionId = module.versionId;

            submodules.push(submodule);

            for (const element of submodule.elements) {

              if (element.active) {
                // Heeft het element comments? Deze moeten naar de commentStore
                if (element.logs) {
                  for (const elementLog of element.logs) {
                    elementLog.elementId = element._id;
                    elementLog.submoduleId = submodule._id;
                    elementLog.moduleId = module._id;
                    elementLog.projectId = this.project._id;
                    elementLog.versionId = this.project.versionId;
                    elementLogs.push(elementLog);
                  }
                }
                // Toevoegen van ontbrekende data op element niveau

                // These are all required to fully define a unique element
                element.submoduleId = submodule._id;
                element.moduleId = module._id;
                element.projectId = this.project._id;
                element.versionId = this.project.versionId;

                elements.push(element);
              }
            }
          }
        }
      }
    }
    this.projectModuleStore.setState(modules);
    this.projectSubmoduleStore.setState(submodules);
    this.projectElementStore.setState(elements);
    this.elementLogStore.setState(elementLogs);
  }

  loadBasicAreas() {
    const basicAreas: BasicArea[] = [];
    for (const basicArea of this.project.basicAreas) {
      basicArea.projectId = this.project._id;
      basicArea.projectLevel = 4;
      basicAreas.push(basicArea);
    }
    this.basicAreaStore.setState(basicAreas);
  }

  loadBuildingsClustersAreas() {
    const buildings: Building[] = [];
    const clusters: Cluster[] = [];
    const areas: Area[] = [];
    for (const building of this.project.buildings) {
      building.projectId = this.project._id;
      building.projectLevel = 2;
      buildings.push(building);

      for (const cluster of building.clusters) {
        cluster.buildingId = building._id;
        clusters.push(cluster);

        for (const area of cluster.areas) {
          area.clusterId = cluster._id;
          area.projectLevel = 5;
          areas.push(area);
        }
      }
    }

    // Now pass all gathered data to the appropricate stores
    this.buildingStore.setState(buildings);
    this.clusterStore.setState(clusters);
    this.areaStore.setState(areas);
  }

  /**
   * Populate user store with project users.
   */
  loadUsers(): void {
    const users: User[] = [];
    for (let user of this.project.users) {
      user = user.userId;
      user.project = {
        active: user.active,
        deleted: user.deleted,
        role: user.projectRole
      };
      users.push(user);
    }
    this.userStore.setState(users);
  }
}
